import { render } from "./teachResearchMenu.vue?vue&type=template&id=559ca3f7&scoped=true"
import script from "./teachResearchMenu.vue?vue&type=script&lang=js"
export * from "./teachResearchMenu.vue?vue&type=script&lang=js"

import "./teachResearchMenu.vue?vue&type=style&index=0&id=559ca3f7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559ca3f7"]])

export default __exports__